import React, { useState, useEffect } from 'react';

import Category from '../modules/models/category';
import Subcategory from '../modules/models/subcategory';

import { trackView, trackSearch } from '../utils/googleAnalytics';

import SearchBar from '../components/searchBar';
import Categories from '../components/categories';
import Footer from '../components/footer';
import TaglineV4 from '../components/tagline-v4';
import Navbar from '../components/navbar';

const HomeV4 = () => {
    const json: Category[] = require('../modules/cheatsheet-v4.json');
    const [cheatsheet, setCheatsheet] = useState<Category[]>(json);

    useEffect(() => {
        trackView('/cheatsheet/tailwind-css-4');

        // SEO: update document title and meta tags for v4 page
        document.title = 'Tailwind CSS v4 Cheat Sheet';

        const setMeta = (selector: string, attr: string, value: string) => {
            const el = document.querySelector(selector);
            if (el) el.setAttribute(attr, value);
        };

        const title = 'Tailwind CSS v4 CheatSheet — New Classes, Utilities & Breaking Changes';
        const description = 'Complete Tailwind CSS v4 cheat sheet with all utility classes, CSS properties, new 3D transforms, container queries, inset shadows and more. Updated for Tailwind v4.';
        const canonical = 'https://www.creative-tim.com/twcomponents/cheatsheet/tailwind-css-4';
        const image = 'https://raw.githubusercontent.com/creativetimofficial/public-assets/master/twcomponents/twcomponents-cheatsheet-thumb.png';

        setMeta('meta[name="title"]', 'content', title);
        setMeta('meta[name="description"]', 'content', description);
        setMeta('link[rel="canonical"]', 'href', canonical);
        setMeta('meta[property="og:title"]', 'content', title);
        setMeta('meta[property="og:description"]', 'content', description);
        setMeta('meta[property="og:image"]', 'content', image);
        setMeta('meta[name="twitter:title"]', 'content', title);
        setMeta('meta[name="twitter:description"]', 'content', description);
        setMeta('meta[name="twitter:image"]', 'content', image);

        return () => {
            // Restore original meta when navigating away
            document.title = 'Tailwind CSS Cheat Sheet';
            setMeta('meta[name="title"]', 'content', 'Tailwind CSS CheatSheet for Beginners and Not Only');
            setMeta('meta[name="description"]', 'content', 'Find quickly all the class names and CSS properties with this interactive cheat sheet. The only Tailwind CheatSheet you will ever need!');
            setMeta('link[rel="canonical"]', 'href', 'https://www.creative-tim.com/twcomponents/cheatsheet');
            setMeta('meta[property="og:title"]', 'content', 'Tailwind CSS CheatSheet for Beginners and Not Only');
            setMeta('meta[property="og:description"]', 'content', 'Find quickly all the class names and CSS properties with this interactive cheat sheet. The only Tailwind CheatSheet you will ever need!');
            setMeta('meta[name="twitter:title"]', 'content', 'Tailwind CSS CheatSheet for Beginners and Not Only');
            setMeta('meta[name="twitter:description"]', 'content', 'Find quickly all the class names and CSS properties with this interactive cheat sheet. The only Tailwind CheatSheet you will ever need!');
        };
    }, []);

    const search = (text: string) => {
        let newCheatsheet: Category[] = json.map((category: Category) => {
            if (category.title.toLowerCase().includes(text)) {
                return category;
            } else {
                return {
                    title: category.title,
                    content: category.content.map((subcategory: Subcategory) => {
                        if (
                            subcategory.title.toLowerCase().includes(text) ||
                            subcategory.description.toLowerCase().includes(text)
                        ) {
                            return subcategory;
                        } else {
                            return {
                                title: subcategory.title,
                                docs: subcategory.docs,
                                description: subcategory.description,
                                table: subcategory.table.filter((tr) => {
                                    for (let td = 0; td < tr.length; td++) {
                                        if (tr[td].includes(text)) {
                                            return true;
                                        }
                                    }
                                    return false;
                                }),
                            };
                        }
                    })
                }
            };
        });

        setCheatsheet(newCheatsheet);
        trackSearch(text);
    };

    return (
        <main className={"tracking-wide font-roboto min-h-screen grid content-start " + (JSON.parse(localStorage.getItem('darkMode') || '{}') ? 'dark bg-gray-900' : '')}>
            <Navbar />
            <TaglineV4 />
            <SearchBar searchFilter={search} />
            <Categories cheatsheet={cheatsheet} />
            <Footer />
        </main>
    );
}

export default HomeV4;
